import { Controller } from "@hotwired/stimulus"

// Контроллер для кнопки «Добавить» в form_list.
// Генерирует пустую строку-форму и вставляет в контейнер.
export default class extends Controller {
  static values = {
    container: String,       // DOM id контейнера строк
    url: String,             // save_row URL
    componentId: String,     // component id
    drillPk: String,
    fields: { type: Array, default: [] },
    gridStyle: String,
    deleteEnabled: { type: Boolean, default: false }
  }

  add() {
    const container = document.getElementById(this.containerValue)
    if (!container) return

    const tempId = `new_${Date.now()}`
    const rowDomId = `form_list_row_${this.componentIdValue}_${tempId}`
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content || ''
    const drillPk = this.drillPkValue || ''

    let deleteCol = ''
    if (this.deleteEnabledValue) {
      deleteCol = '<div class="px-1 py-1"></div>'
    }

    let fieldCols = ''
    for (const field of this.fieldsValue) {
      const inputKey = field.input_key || field.key
      const inputName = `fields[${inputKey}]`
      const fieldId = `${rowDomId}_${inputKey}`
      const readOnly = field.read_only
      const roAttr = readOnly ? 'readonly disabled' : ''
      const roClass = readOnly ? 'text-gray-400' : ''

      let input = ''
      switch (field.display_type) {
        case 'number':
          input = `<input type="number" name="${inputName}" id="${fieldId}" value="" ${roAttr}
                     class="w-full text-xs border-0 border-b border-blue-300 focus:border-blue-400 focus:ring-0 bg-blue-50/30 px-1 py-0.5 ${roClass}">`
          break
        case 'date':
          input = `<input type="datetime-local" name="${inputName}" id="${fieldId}" value="" ${roAttr}
                     class="w-full text-xs border-0 border-b border-blue-300 focus:border-blue-400 focus:ring-0 bg-blue-50/30 px-1 py-0.5 ${roClass}">`
          break
        case 'bool':
        case 'boolean':
          input = `<div class="flex items-center justify-center">
                     ${readOnly ? '' : `<input type="hidden" name="${inputName}" value="0">`}
                     <input type="checkbox" name="${inputName}" id="${fieldId}" value="1" ${readOnly ? 'disabled' : ''}
                            class="h-3.5 w-3.5 rounded border-gray-300 text-blue-600 focus:ring-blue-500">
                   </div>`
          break
        case 'textarea':
          input = `<textarea name="${inputName}" id="${fieldId}" rows="1" ${roAttr}
                     class="w-full text-xs border-0 border-b border-blue-300 focus:border-blue-400 focus:ring-0 bg-blue-50/30 px-1 py-0.5 resize-none ${roClass}"></textarea>`
          break
        case 'tags':
          input = `<div data-controller="dae20--tags-input"
                        data-dae20--tags-input-field-name-value="${inputName}"
                        data-dae20--tags-input-values-value="[]">
                     <div data-dae20--tags-input-target="container" class="flex flex-wrap gap-0.5 mb-0.5 empty:hidden"></div>
                     <div class="flex gap-0.5">
                       <input type="text" data-dae20--tags-input-target="input"
                              data-action="keydown->dae20--tags-input#onKeydown blur->dae20--tags-input#onBlur"
                              placeholder="Enter"
                              class="w-full text-xs border-0 border-b border-blue-300 focus:border-blue-400 focus:ring-0 bg-blue-50/30 px-1 py-0.5 ${roClass}" ${roAttr}>
                     </div>
                     <div data-dae20--tags-input-target="hiddens"></div>
                   </div>`
          break
        default:
          input = `<input type="text" name="${inputName}" id="${fieldId}" value="" ${roAttr}
                     class="w-full text-xs border-0 border-b border-blue-300 focus:border-blue-400 focus:ring-0 bg-blue-50/30 px-1 py-0.5 ${roClass}">`
      }

      fieldCols += `<div class="px-1 py-0.5">${input}</div>`
    }

    const html = `
      <div id="${rowDomId}" class="form-list-row group bg-blue-50/20 hover:bg-blue-50/50 transition-colors">
        <form action="${this.urlValue}" method="post" data-controller="dae20--form-list-row"
              data-action="change->dae20--form-list-row#scheduleSubmit"
              data-dae20--form-list-row-row-dom-id-value="${rowDomId}">
          <input type="hidden" name="authenticity_token" value="${csrfToken}">
          <input type="hidden" name="new_record" value="1">
          <input type="hidden" name="base_rec_id" value="">
          <input type="hidden" name="row_dom_id" value="${rowDomId}">
          ${drillPk ? `<input type="hidden" name="drill_pk" value="${drillPk}">` : ''}
          <div class="grid gap-0 items-center" style="${this.gridStyleValue}">
            ${deleteCol}
            ${fieldCols}
            <div class="px-1 py-1 flex items-center justify-center" data-dae20--form-list-row-target="status"></div>
          </div>
        </form>
      </div>
    `

    container.insertAdjacentHTML('beforeend', html)

    // Focus на первое не-readonly поле
    const newRow = document.getElementById(rowDomId)
    if (newRow) {
      const firstInput = newRow.querySelector('input:not([type=hidden]):not([readonly]):not([disabled]), textarea:not([readonly]):not([disabled]), select:not([disabled])')
      if (firstInput) firstInput.focus()
    }
  }
}
